import React from 'react';
import { Card } from '@fluentui/react-components';
import {
  VNotificationCategoryEnum,
  VNotificationTypeEnum,
  VTank,
} from '../../../services';
import appConfig from '../../../config.app';
import Message from '../../../components/message';
import AlarmCard from './alarmCard';

interface AlarmListProps {
  tanks: VTank[];
  style: React.CSSProperties | undefined;
  onSnooze: (tank: VTank, notificationType: VNotificationTypeEnum) => void;
  onUnsnooze: (tankId: string, notificationType: VNotificationTypeEnum) => void;
}

const AlarmList: React.FC<AlarmListProps> = ({
  tanks,
  style,
  onSnooze,
  onUnsnooze,
}) => {
  const genAlarmCards = (tank: VTank) => {
    const alarmCards: React.ReactNode[] = [];
    [
      VNotificationTypeEnum.TankWeightLow,
      VNotificationTypeEnum.TankWeightLossFast,
      VNotificationTypeEnum.TankWeightLossCritical,
      VNotificationTypeEnum.TankEvaporationRateHigh,
      VNotificationTypeEnum.CaddyBatteryCritical,
      VNotificationTypeEnum.CaddyTemperatureLow,
      VNotificationTypeEnum.TankOffline,
    ].forEach((notificationType) => {
      const boolField = notificationType.split(' ').slice(1).join(''); // like "WeightLow"
      const strField = boolField.charAt(0).toLowerCase() + boolField.slice(1); // like "weightLow"
      if (tank[`is${boolField}` as keyof VTank]) {
        alarmCards.push(
          <AlarmCard
            key={`${tank.id}-${notificationType}`}
            tankId={tank.id}
            tankName={tank.name}
            notificationType={notificationType}
            notificationCategory={VNotificationCategoryEnum.Alarming}
            snoozeUtil={tank[`${strField}SnoozeUntil` as keyof VTank] as string}
            snoozeNote={tank[`${strField}SnoozeNote` as keyof VTank] as string}
            isSnoozed={tank[`is${boolField}Snoozed` as keyof VTank] as boolean}
            onSnooze={() => onSnooze(tank, notificationType)}
            onUnsnooze={() => onUnsnooze(tank.id, notificationType)}
          />,
        );
      }
    });
    return alarmCards;
  };

  const alarmCards = tanks.filter((tank) => tank != null).flatMap((tank) => genAlarmCards(tank));

  return <Card style={{
    ...style,
    height: '100%',
    padding: 'unset',
  }}>
    {
      alarmCards.length
        ? (<div style={{ overflow: 'hidden auto', padding: 20 }}>
            { alarmCards }
          </div>
        )
        : (
          <Message message={appConfig.errMsg.NOT_FOUND_ALARMS} status='info' />
        )
    }
  </Card>;
};

export default AlarmList;
